import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useRepo from '@/nebula/repo';
import { DateTime } from 'luxon';
import { account as accountConfig } from 'shared/api/query/configs.json';
import { computed } from 'vue';
import { uploadFile } from '@/lib/image/image';

export default function useLoggedInUserAccount() {
  const accountRepo = useRepo(accountConfig.model);
  const { loggedInUser } = useLoggedInUser();

  const loggedInUserAccount = computed(() => {
    if (loggedInUser.value === null || loggedInUser.value.account === undefined) {
      return { accountSettings: {}, companyImage: {}, goalSettings: {} };
    }

    const account = accountRepo.selectSingle(loggedInUser.value.account.uid);
    if (account === undefined) {
      return { accountSettings: {}, companyImage: {}, goalSettings: {} };
    }

    return account;
  });

  const uploadImage = (blob) => uploadFile(
    blob,
    () => {
    },
  ).then((response) => {
    if (response.status !== 200) {
      throw new Error('uploading image failed');
    }
    return response;
  }).then((response) => {
    const companyImage = () => {
      if (loggedInUserAccount.value.companyImage === null) {
        return { blob: response.data };
      }
      return {
        uid: loggedInUserAccount.value.companyImage.uid,
        blob: response.data,
      };
    };
    return accountRepo.updateSingle({
      uid: loggedInUserAccount.value.uid,
      companyImage: companyImage(),
    }, { optimistic: false });
  });

  const deleteImage = () => {
    if (loggedInUserAccount.value.companyImage === null) {
      return new Promise((resolve) => {
        resolve();
      });
    }
    return accountRepo.updateSingle({
      uid: loggedInUserAccount.value.uid,
      companyImage: {
        uid: loggedInUserAccount.value.companyImage.uid,
        deletedAt: DateTime.local().toISO(),
      },
    }, { optimistic: false });
  };

  return {
    loggedInUserAccount,
    uploadImage,
    deleteImage,
    updateSingle: accountRepo.updateSingle,
    getList: accountRepo.getList,
  };
}
